import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useSeo } from "@/hooks/useSeo";
import FocusBanner from "./components/FocusBanner";
import CategoryEntries from "./components/CategoryEntries";
import LatestFilmNews from "./components/LatestFilmNews";
import EntertainmentList from "./components/EntertainmentList";
import MoviePicks from "./components/MoviePicks";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  useSeo({
    title: "红桃网_最新影视资讯与娱乐内容分享平台",
    description:
      "红桃网为您提供最新的影视资讯、娱乐新闻及多样化影视资源，覆盖电影、电视剧等各类内容，满足用户多元化娱乐需求。",
    keywords:
      "红桃网,影视资讯,娱乐新闻,电影推荐,电视剧更新,在线视频,影视资源",
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 w-full">
        <FocusBanner />
        <CategoryEntries />
        <LatestFilmNews />
        <EntertainmentList />
        <MoviePicks />
        <SiteIntro />
      </main>
      <Footer />
    </div>
  );
}